import { render } from "./PosMesas.vue?vue&type=template&id=1496e010&scoped=true"
import script from "./PosMesas.vue?vue&type=script&lang=js"
export * from "./PosMesas.vue?vue&type=script&lang=js"

import "./PosMesas.vue?vue&type=style&index=0&id=1496e010&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1496e010"]])

export default __exports__